import { render, staticRenderFns } from "./PanelMunicipality.vue?vue&type=template&id=dc8a9f26&lang=pug"
import script from "./PanelMunicipality.vue?vue&type=script&lang=js"
export * from "./PanelMunicipality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports